export default "/fonts/vendor/@fontsource/lato/files/lato-latin-ext-900-normal.woff?1210a240c0d692bb7f43f1c3de8413b0";